import { useState, useEffect, useRef } from "react";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import { useUser } from "../../../contexts/userContext/userContext.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import useOnClickOutside from "../../../hooks/useOnClickOutside.js";
import { sortList } from "./Helpers.js";
import NotificationList from "./NotificationList.js";
import AnimationContainer from "../AnimationContainer/AnimationContainer.js";
import Skeleton from "react-loading-skeleton";

import "./Notifications.scss";

const Notifications = ({
  setCountNewNotifications = () => {},
  openNotifications,
  setOpenNotifications = () => {},
}) => {
  const { getUserData } = useUser();
  const [userNotificationsList, setUserNotificationsList] = useState(null);
  const [displayList, setDisplayList] = useState(null);
  const [statusDisplay, setStatusDisplay] = useState("all");
  const [loading, setLoading] = useState(false);
  const [openThreeDots, setOpenThreeDots] = useState(null);
  const [isEmptyList, setIsEmptyList] = useState(false);
  const [isEmptyListForDisplay, setisEmptyListForDisplay] = useState(false);
  const { getTextByKey, getLanguage } = useContent();
  const ref = useRef();
  useOnClickOutside(ref, () => setOpenThreeDots(null));

  const getAllNotificationsByUserId = async () => {
    setLoading(true);
    const parameters = {
      reactOrAngular: "angular",
      culture: getLanguage(),
    };
    const response = await apiRequest(
      "Notifications",
      "GetAllNotificationsByUserId",
      parameters
    );
    if (response.status === "success") {
      if (response.data) {
        if (response.data.length > 0) {
          setIsEmptyList(false);
          const withOutHidden = response.data.filter(
            (item) => !item.UserNotificationHidden
          );
          setUserNotificationsList(sortList(withOutHidden));
          const unreadList = null;
          if (unreadList === null || unreadList.length <= 0) {
            setStatusDisplay("all");
            setDisplayList(sortList(response.data));
          } else {
            setDisplayList(sortList(unreadList));
          }
        } else {
          setIsEmptyList(true);
          setUserNotificationsList(sortList(response.data));
        }
      }
    }
    setLoading(false);
  };

  const updateUserNotification = async (item) => {
    const body = {
      UserNotificationId: item.NotificationId,
      TemplateNotificationId: item.TemplateId,
      UserNotificationUserId: item.UserId,
      UserNotificationDisplayed: item.UserNotificationDisplayed,
      UserNotificationClicked: item.UserNotificationClicked,
      UserNotificationImportant: item.UserNotificationImportant,
      UserNotificationHidden: item.UserNotificationHidden,
    };
    const response = await apiRequest(
      "Notifications",
      "UpdateUserNotification",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
      }
    }
  };

  const updateNotification = (notification, type) => {
    let tempArray = userNotificationsList.filter(
      (item) => item.NotificationId !== notification.NotificationId
    );
    let tempNotification = { ...notification };
    if (tempNotification) {
      if (type === "hidden") {
        tempNotification.UserNotificationHidden = true;
      } else if (type === "important") {
        tempNotification.UserNotificationImportant =
          !tempNotification.UserNotificationImportant;
        tempNotification.UserNotificationClicked = true;
        tempNotification.UserNotificationDisplayed = true;
      } else {
        tempNotification.UserNotificationDisplayed = true;
        tempNotification.UserNotificationClicked = true;
      }
      tempArray.push(tempNotification);
      setUserNotificationsList(sortList(tempArray));
      setOpenThreeDots(null);
      updateUserNotification(tempNotification);
      tempNotification.NotificationLinkUrl = fixPopUpButtonLink(
        tempNotification.NotificationLinkUrl,
        tempNotification
      );
      if (type === "click") {
        //redirectByClick(tempNotification, getLanguage());
      }
    }
  };

  const fixPopUpButtonLink = (str, tempNotification) => {
    let temp = str;
    if (temp) {
      if (getUserData()) {
        if (getUserData().Subscribtion_Expired) {
          temp = temp.replace("#subscriptiontype#", "subscription");
          if (getUserData().Subscription === "JM Business") {
            temp = temp.replace("#subscriptionpackage#", "business");
          } else if (getUserData().Subscription === "JM Pro") {
            temp = temp.replace("#subscriptionpackage#", "pro");
          }
        }

        if (tempNotification !== null || tempNotification !== undefined) {
          if (
            tempNotification.EncryptedMailId !== null ||
            tempNotification.EncryptedMailId !== undefined
          ) {
            if (str.includes("#mailid#")) {
              temp = temp.replace("#mailid#", tempNotification.EncryptedMailId);
            }
          }
        }
      }
    }
    return temp;
  };

  useEffect(() => {
    if (userNotificationsList) {
      if (statusDisplay === "all") {
        setDisplayList(userNotificationsList);
      } else if (statusDisplay === "unread") {
        if (
          userNotificationsList.filter((item) => !item.UserNotificationClicked)
            .length === 0 ||
          userNotificationsList.filter(
            (item) => !item.UserNotificationClicked
          ) === null
        ) {
          setDisplayList(null);
        } else {
          setDisplayList(
            sortList(
              userNotificationsList.filter(
                (item) => !item.UserNotificationClicked
              )
            )
          );
        }
      } else if (statusDisplay === "important") {
        if (
          userNotificationsList.filter((item) => item.UserNotificationImportant)
            .length === 0 ||
          userNotificationsList.filter(
            (item) => item.UserNotificationImportant
          ) === null
        ) {
          setDisplayList(null);
        } else {
          setDisplayList(
            sortList(
              userNotificationsList.filter(
                (item) => item.UserNotificationImportant
              )
            )
          );
        }
      } else if (statusDisplay === "") {
        if (!sortList(userNotificationsList).length > 0) {
          setDisplayList(null);
        } else {
          setDisplayList(sortList(userNotificationsList));
        }
      }
    }
  }, [statusDisplay, userNotificationsList]);

  useEffect(() => {
    if (userNotificationsList !== null) {
      if (displayList === null || displayList.length === 0) {
        setisEmptyListForDisplay(true);
      }
    }
  }, [displayList]);
  useEffect(() => {
    setCountNewNotifications(0);
    if (openNotifications) {
      if (userNotificationsList === null) {
        getAllNotificationsByUserId();
      }
    }
  }, [openNotifications]);

  const skeletonList = () => {
    let list = ["1", "2", "3", "4"];
    const listSkeletons = [
      {
        title: 200,
        line1: 260,
        line2: 180,
        time: 100,
      },
      {
        title: 220,
        line1: 280,
        line2: 160,
        time: 80,
      },
      {
        title: 190,
        line1: 270,
        line2: 180,
        time: 90,
      },
      {
        title: 250,
        line1: 290,
        line2: 180,
        time: 70,
      },
    ];
    return (
      <>
        <div className="header-notification">
          <h3>
            <Skeleton width={200} />
          </h3>
          <ul className="options-list">
            <li>
              <span className="option-title">
                <Skeleton width={100} />
              </span>
            </li>
            <li>
              <span className="option-title">
                <Skeleton width={100} />
              </span>
            </li>
            <li>
              <span className="option-title">
                <Skeleton width={100} />
              </span>
            </li>
          </ul>
        </div>
        <div className="notifications-list">
          <ul className="list-items-notifications skeleton-list">
            {listSkeletons.map((item, i) => (
              <li className={`notification-row displayed skeleton`} key={i}>
                <div className="notification-div">
                  <div className="image-div skeleton-image">
                    <Skeleton circle height={50} width={50} />
                  </div>
                  <div className="desctription-div">
                    <div className="title-and-text">
                      <span className="title">
                        <Skeleton width={item.title} height={18} />
                      </span>
                      <span className="text">
                        <Skeleton width={item.line1} />
                        <Skeleton width={item.line2} />
                      </span>
                    </div>
                    <span className="time">
                      <Skeleton width={item.time} height={12} />
                    </span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </>
    );
  };

  return (
    <div className="notifications-container">
      <AnimationContainer
        animationOn={openNotifications}
        animationClassName="side-bar-animation"
      >
        <div className={`side-notification open-list`}>
          <div
            onClick={() => setOpenNotifications(false)}
            className="exit-icon"
          >
            <Icon name="x" />
          </div>
          {!loading ? (
            !isEmptyList ? (
              <div className="header-notification">
                <h3>{getTextByKey("notifications-title")}</h3>
                <ul className="options-list">
                  <li
                    className={`${statusDisplay === "all" ? "active" : ""}`}
                    onClick={() => setStatusDisplay("all")}
                  >
                    <span className="option-title">
                      {getTextByKey("all-notifications")}
                    </span>
                  </li>
                  <li
                    className={`${
                      statusDisplay === "important" ? "active" : ""
                    }`}
                    onClick={() => setStatusDisplay("important")}
                  >
                    <span className="star-icon">
                      <i className="fas fa-star"></i>
                    </span>
                    <span className="option-title">
                      {getTextByKey("important-notifications")}
                    </span>
                  </li>
                  <li
                    className={`${statusDisplay === "unread" ? "active" : ""}`}
                    onClick={() => setStatusDisplay("unread")}
                  >
                    <span className="option-title">
                      {getTextByKey("unread-notifications")}
                    </span>
                  </li>
                </ul>
              </div>
            ) : (
              <div className="empty-notifications">
                <Icon iconClass="no-forms-img" name="no-forms" xxxl="true" />
                <p>{getTextByKey("empty-notifications")}</p>
              </div>
            )
          ) : (
            skeletonList()
            // <LoaderContainer isLoading={loading} isPreloader={true} />
          )}
          {displayList ? (
            <NotificationList
              updateNotification={updateNotification}
              displayList={displayList}
              setOpenThreeDots={setOpenThreeDots}
              openThreeDots={openThreeDots}
            />
          ) : isEmptyListForDisplay ? (
            <div className="empty-notifications">
              <Icon iconClass="no-forms-img" name="no-forms" xxxl="true" />
              <p>
                {getTextByKey(
                  statusDisplay === "unread"
                    ? "empty-notifications-unread"
                    : statusDisplay === "important"
                    ? "empty-notifications-important"
                    : "empty-notifications-important"
                )}
              </p>
            </div>
          ) : null}
        </div>
      </AnimationContainer>
    </div>
  );
};

export default Notifications;
